<template>
  <div class="container">
    <div class="header">
      <div class="inner">
        <img src="../../assets/img/share/logo.png" alt="" />
        <div class="detail">
          <span class="version">V{{ version }}</span>
        </div>
      </div>
    </div>
    <div class="slogan">
      <img src="../../assets/img/share/slogan.png" alt="" />
    </div>
    <div class="swipers">
      <carousel-3d
        :display="3"
        :width="width"
        :height="height"
        @before-slide-change="onSlideChange"
      >
        <slide v-for="(item, idx) in imgs" :key="idx" :index="idx">
          <div
            :class="[
              's_item_box',
              current == idx ? 'actived' : current + 1 == idx ? '' : 'prev',
            ]"
          >
            <img v-lazy="item" />
          </div>
        </slide>
      </carousel-3d>
      <img class="dot" src="../../assets/img/share/square.png" alt="" />
      <img class="dot dot2" src="../../assets/img/share/circle.png" alt="" />
      <img class="downbg" src="../../assets/img/share/bg_down.png" alt="" />
      <button class="download" v-if="isIOS" @click="onOpenStore"></button>
      <button class="download" v-else @click="onDownload"></button>
    </div>
  </div>
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
import { apiDownload } from "../../api";
import img1 from "../../assets/img/share/1.jpg";
import img2 from "../../assets/img/share/2.jpg";
import img3 from "../../assets/img/share/3.jpg";
import img4 from "../../assets/img/share/4.jpg";

export default {
  data: () => ({
    page: {
      current: 1,
      size: 50,
      total: 0,
    },
    loop: true,
    imgs: [img1, img2, img3, img4],
    downloadUrl: null,
    current: 0,
    isIOS: false,
    version: "",
  }),
  computed: {
    width() {
      return window.innerWidth - 72;
    },
    height() {
      return window.innerHeight - 196;
    },
  },
  components: {
    Carousel3d,
    Slide,
  },
  methods: {
    async getData() {
      const { data: resp } = await apiDownload({ ...this.page });
      this.version = resp.version_no;
      this.downloadUrl = resp.qr_code;
    },
    onSlideChange (index) {
      this.current = index;
    },
    onBack() {
      return backapp.postMessage("back");
    },
    onDownload() {
      window.location.href = this.downloadUrl;
    },
    onOpenStore() {
      window.location.href = "https://itunes.apple.com/app/id1598049623";
    },
  },
  mounted() {
    this.getData();
    this.isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  font-family: "Microsoft YaHei", sans-serif;
  text-align: left;
  background: #ffffff;
  .header {
    width: 100%;
    height: 36px;
    background: #2c2e35;
    .inner {
      display: flex;
      justify-content: space-between;
      img {
        width: 136px;
        height: 28px;
        display: block;
        margin: 4px 0 0 12px;
      }
      .detail {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        height: 36px;
        color: #fff;
        margin-right: 0.26rem;
      }
    }
  }

  .slogan {
    width: 100vw;
    height: 375px;
    background-image: url("../../assets/img/share/bg_up.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: relative;
    z-index: 1;
    img {
      width: 340px;
      margin: 13px auto;
      display: block;
    }
  }

  .swipers {
    width: 100vw;
    height: calc(100vh - 196px);
    margin-top: -233px;
    position: relative;
    z-index: 2;
    .carousel-3d-slide {
      border: none !important;
      background: none !important;
      .s_item_box {
        width: 245px;
        height: 399px;
        overflow: hidden;
        box-sizing: content-box;
        margin: 0 auto;
        transition: all linear .5s;
        img {
          margin: 4px 0 0 12px;
          width: 221px;
          height: 392px;
        }
        &.actived {
          background-image: url("../../assets/img/share/imgbg.png");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
        }
      }
    }
    .dot,
    .downbg {
      display: block;
      position: absolute;
      z-index: 1;
    }
    .downbg {
      width: 183px;
      height: 270px;
      bottom: 0;
      left: 0;
    }
    .dot {
      width: 8px;
      height: 8px;
      top: 136px;
      left: 18px;
      &.dot2 {
        width: 11px;
        height: 11px;
        top: -19px;
        right: 26px;
        left: inherit;
      }
    }
    .download {
      background-image: url("../../assets/img/share/button.png");
      background-color: transparent;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      width: 267px;
      height: 63px;
      position: absolute;
      z-index: 3;
      display: block;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 17px;
      border: 0;
      outline: none;
    }
  }
}

@media screen and (min-width: 414px) {
  .inner,
  .swipers {
    width: 414px !important;
    margin: 0 auto;
  }
}
</style>
